package pl.decks.personal.theme

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors

internal data class SitePalette(
    val surface: Color,
    val highlight: Color,
    val accents: Accents,
    val profile: ProfileColors,
    val military: Military,
    val battery: Battery,
) {
    data class Accents(
        val primary: Color,
        val secondary: Color,
    )

    data class ProfileColors(
        val systems: Color,
        val software: Color,
        val platforms: Color,
        val analytics: Color,
        val product: Color,
        val culture: Color,
    )

    data class Military(
        val low: MilitaryBadgeColors,
        val mid: MilitaryBadgeColors,
        val high: MilitaryBadgeColors,
    )

    data class MilitaryBadgeColors(
        val badge: Color,
        val stroke: Color,
        val insignia: Color,
    )

    data class Battery(
        val empty: BatteryColors,
        val low: BatteryColors,
        val mid: BatteryColors,
        val high: BatteryColors,
        val full: BatteryColors,
    )

    data class BatteryColors(
        val stroke: Color,
        val fill: Color,
        val body: Color = Colors.Transparent,
    )
}
